const compatModules = {};import * as Mod1 from "./discourse/components/yearly-review-admin-notice";
compatModules["discourse/components/yearly-review-admin-notice"] = Mod1;

export * as discourse$components$yearly__review__admin__notice$$__module from "./discourse/components/yearly-review-admin-notice";
export {
janNextYear as discourse$components$yearly__review__admin__notice$$janNextYear,
default as discourse$components$yearly__review__admin__notice$$default
} from "./discourse/components/yearly-review-admin-notice";
import * as Mod2 from "./discourse/initializers/yearly-review-admin-notice";
compatModules["discourse/initializers/yearly-review-admin-notice"] = Mod2;

export * as discourse$initializers$yearly__review__admin__notice$$__module from "./discourse/initializers/yearly-review-admin-notice";
export {
default as discourse$initializers$yearly__review__admin__notice$$default
} from "./discourse/initializers/yearly-review-admin-notice";
export default compatModules;
